import { Grid, InputAdornment, TextField, Typography, makeStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import React, { useMemo, useState } from 'react';
import { AppStorage } from '../../../../Core/Service/storage-service';
import { Tcard } from '../Dashboard/TcardTemplates/mainTcard';

const useStyles = makeStyles({
    toolbar: {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        background: '#fff',
        paddingBottom: '6px',
        borderBottom: '1px solid #e0e0e0'
    },
    list: {
        height: 'calc(100vh - 300px)',
        minHeight: '300px',
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': { width: '0.4em', height: '0.4em' },
        '&::-webkit-scrollbar-thumb': { backgroundColor: '#1976d2', borderRadius: '4px' }
    },
    row: {
        cursor: 'pointer',
        border: '1px solid #d5d5d5',
        borderRadius: '3px',
        overflow: 'hidden',
        transition: 'box-shadow 0.15s ease-in-out',
        '&:hover': { boxShadow: '0 3px 10px rgba(0,0,0,0.25)' }
    }
});

const getCustomerName = (booking) => booking?.cust || booking?.tCardsCustomerName || booking?.customerName || booking?.customer || '';

const JobBookingDetailsList = (props) => {
    const classes = useStyles();
    const portalSetting = AppStorage.getPortalSetting();
    const statusObject = JSON.parse(AppStorage.getTCardStatus() || '[]');

    const rows = useMemo(
        () => (props.selectedBookingList || []).map((q) => ({ ...q, id: q.tCardsID || q.id || q.jobID || q.headerRecordID })),
        [props.selectedBookingList]
    );

    const [searchText, setSearchText] = useState('');

    const filteredRows = useMemo(() => {
        const term = searchText.trim().toLowerCase();
        if (!term) return rows;
        return rows.filter((r) => {
            const reg = `${r.registration || ''}`.toLowerCase();
            const cust = getCustomerName(r).toLowerCase();
            const wip = `${r.wipNumber || ''}`.toLowerCase();
            return reg.includes(term) || cust.includes(term) || wip.includes(term);
        });
    }, [rows, searchText]);

    const legendItems = [
        {
            label: portalSetting.portalSettingsCollectionDeliverText,
            background: portalSetting.portalSettingsCollectionDeliverBgColor || 'black',
            color: portalSetting.portalSettingsCollectionDeliverTextColor || 'white',
            st: 'cd'
        },
        {
            label: portalSetting.portalSettingsCustomerWaitingText,
            background: portalSetting.portalSettingsCustomerWaitingBgColor || 'black',
            color: portalSetting.portalSettingsCustomerWaitingTextColor || 'white',
            st: 'waiting'
        },
        {
            label: portalSetting.portalSettingsServiceText,
            background: portalSetting.portalSettingsServiceBgColor || 'black',
            color: portalSetting.portalSettingsServiceTextColor || 'white',
            st: 'service'
        },
        {
            label: portalSetting.portalSettingsInspectionText,
            background: portalSetting.portalSettingsInspectionBgColor || 'black',
            color: portalSetting.portalSettingsInspectionTextColor || 'white',
            st: 'inspection'
        },
        {
            label: portalSetting.portalSettingsMOTText,
            background: portalSetting.portalSettingsMOTBgColor || 'black',
            color: portalSetting.portalSettingsMOTTextColor || 'white',
            st: 'mot'
        },
        {
            label: portalSetting.portalSettingsRepairText,
            background: portalSetting.portalSettingsRepairBgColor || 'black',
            color: portalSetting.portalSettingsRepairTextColor || 'white',
            st: 'repair'
        },
        {
            label: portalSetting.portalSettingsNightShiftText,
            background: portalSetting.portalSettingsNightShiftBgColor || 'black',
            color: portalSetting.portalSettingsNightShiftTextColor || 'white',
            st: 'ns'
        },
        {
            label: portalSetting.portalSettingsRecallJobText,
            background: portalSetting.portalSettingsRecallJobBgColor || 'black',
            color: portalSetting.portalSettingsRecallJobTextColor || 'white',
            st: 'recall'
        },
        {
            label: portalSetting.portalSettingsTachoText,
            background: portalSetting.portalSettingsTachoBgColor || 'black',
            color: portalSetting.portalSettingsTachoTextColor || 'white',
            st: 'tacho'
        }
    ];

    return (
        <Grid container>
            <Grid item xs={12} className={classes.toolbar}>
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={12} sm={8}>
                        <TextField
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            autoFocus
                            placeholder="Search registration, customer or WIP"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} style={{ textAlign: 'right' }}>
                        <Typography variant="body2" color="textSecondary">
                            {filteredRows.length} of {rows.length} job{rows.length === 1 ? '' : 's'}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} className={classes.list}>
                {filteredRows.length === 0 ? (
                    <Typography variant="body2" color="textSecondary" style={{ padding: '20px', textAlign: 'center' }}>
                        No bookings match your search.
                    </Typography>
                ) : (
                    <Grid container spacing={1} style={{ width: '100%', margin: 0, paddingTop: '8px' }}>
                        {filteredRows.map((k, kIdx) => {
                            let tempStatusObj = statusObject.find((s) => s.id == k.sid);
                            return (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={3}
                                    key={k.id || k.tCardsID || kIdx}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        props.handleCardClick && props.handleCardClick(k);
                                    }}
                                >
                                    <div className={classes.row}>
                                        <Tcard
                                            hideBookingDate={true}
                                            legendItems={legendItems}
                                            handleTcardOpen={() => props.handleCardClick && props.handleCardClick(k)}
                                            date={k.bd || k.bookingDate}
                                            customer={getCustomerName(k)}
                                            isLoanVehicle={k.loanVehicle || k.tCardsLoanVehicle}
                                            registration={k.registration}
                                            bg={tempStatusObj?.bgc || '#f9f9f9'}
                                            color={tempStatusObj?.bgc || '#f9f9f9'}
                                            textColor={tempStatusObj?.tc || '#000000'}
                                            tCardsID={k.tCardsID || null}
                                            isTCard={Boolean(k.tCardsID)}
                                            breakdown={k.breakdown}
                                            breakdownStatus={k.breakdownStatus}
                                            breakdownTime={k.breakdownTime}
                                            status={{
                                                recall: k.tCardsIsRecallJob,
                                                tacho: k.tCardsIsTacho,
                                                motdate: k.tCardsMOTDate,
                                                motloc: k.tCardsMotloc,
                                                mot: k.tCardsIsMOT,
                                                repair: k.tCardsIsRepair,
                                                inspection: k.tCardsIsInspection,
                                                cd: k.tCardsIsCollectionDeliver,
                                                waiting: k.tCardsIsCustomerWaiting,
                                                service: k.tCardsIsService,
                                                ns: k.tCardsIsNightShift
                                            }}
                                        />
                                    </div>
                                </Grid>
                            );
                        })}
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};

export default JobBookingDetailsList;
